import {AsidePanelActionsButton} from '../../../../asidePanel/components/AsidePanelActionsButton/AsidePanelActionsButton';
import {getAsidePanelActionsButtonTooltip} from '../../../../asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import * as React from 'react';
import {IArchiveButton} from './types';
import { ARCHIVE_TITLE, UNARCHIVE_TITLE, UNARCHIVE_TOOLTIP } from './constants';
import {CLASS_ASIDE_PANEL_ACTIONS_BUTTON} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import './_ArchiveButton.scss';

export function ArchiveButton({
    isArchived,
    isEssentialFeature,
    isDisallow,
    isProFeature,
    isShow,
    isShowTooltip,
    className,
    onClick,
    onUnarchive
}: IArchiveButton) {
    if (!isShow) return null;
    const classNameArchive = CLASS_ASIDE_PANEL_ACTIONS_BUTTON + '--archive';
    const classNameUnarchive = CLASS_ASIDE_PANEL_ACTIONS_BUTTON + '--unarchive';
    const UnarchiveIcon = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/unarchive.svg').default;

    return <>
        {isArchived
            ? <AsidePanelActionsButton
                icon={<UnarchiveIcon/>}
                title={UNARCHIVE_TITLE}
                tooltip={getAsidePanelActionsButtonTooltip({
                    direction: 'down',
                    value: UNARCHIVE_TOOLTIP
                })}
                onClick={onUnarchive}
                className={classNameUnarchive}
                isProFeature={isProFeature}
                isEssentialFeature={isEssentialFeature}
            /> : <AsidePanelActionsButton
                className={`
                    ${className}
                    ${classNameArchive}
                `}
                icon={'archive'}
                isDisabled={isDisallow}
                title={ARCHIVE_TITLE}
                tooltip={isShowTooltip ? getAsidePanelActionsButtonTooltip({
                    direction: 'down',
                    value: ARCHIVE_TITLE
                }) : null}
                isProFeature={isProFeature}
                isEssentialFeature={isEssentialFeature}
                onClick={onClick}
            />
        }
    </>
}
